import { INVITE_MODAL_SHOW, INVITE_MODAL_CLOSE } from './types';

export function showInviteModal() {
  return {
    type: INVITE_MODAL_SHOW,
  };
}

export function closeInviteModal() {
  return {
    type: INVITE_MODAL_CLOSE,
  };
}
